import React, {useState, useEffect, forwardRef} from 'react';
import {Toast} from 'antd-mobile-v2';
import {useStore, useStores} from '@/store/hooks';

import './index.less';

export default forwardRef((props, ref) => {
  const {fetchCityList, fetchShopList} = useStore('shopStore');
  const {city_code, shop_id, lat, lon, isShow} = props;
  const [cityList, setCityList] = useState([]);
  const [shopList, setShopList] = useState([]);
  const [cityIdx, setCityIdx] = useState(0);
  const [shopIdx, setShopIdx] = useState(0);
  const [val, setVal] = useState('');

  useEffect(() => {
    queryCityList();
  }, []);

  useEffect(() => {
    init();
  }, [city_code, shop_id, lat, lon, cityList.length]);

  useEffect(() => {
    const cityName = cityList.length && cityList[cityIdx].city_name;
    const shop = shopList.length ? shopList[shopIdx] : {};
    setVal(shop.shop_no ? shop.shop_nick_name : cityName || '全国');
  }, [cityIdx, shopIdx]);

  const queryCityList = async () => {
    const {status, city_list, message} = await fetchCityList();
    if (status === 0) {
      const arr = city_list.filter(item => !/028|761/.test(item.city_id));
      setCityList([{city_name: '全国', city_no: 0, city_id: ''}, ...arr] || []);
    } else {
      Toast.fail(message);
    }
  };

  const init = () => {
    let initCityIdx = 0;
    const city = cityList.filter((item, index) => {
      const flag = city_code === item.city_no;
      if (flag) {
        initCityIdx = index;
        setCityIdx(index);
      }

      return flag;
    })[0];
    if (city) {
      onSelectCity(initCityIdx, city, shopList => {
        let idx = 0,
          flag = false;
        const arr = shopList.filter((item, index) => {
          flag = item.shop_id == shop_id;
          if (flag) {
            idx = index;
          }
          return flag;
        });
        onSelectShop(idx, arr.length ? arr[0] : shopList[0], true, initCityIdx);
      });
    }
  };

  // 查询分院
  const queryShopList = async (cityCode, cb) => {
    const {lat, lon} = props;
    const {status, shop_list, message} = await fetchShopList({
      query_type: 1,
      page_no: 1,
      page_size: 999,
      city_no: cityCode || '',
      prog_opt: 8,
      lati: lat * 1000000 || '',
      longi: lon * 1000000 || '',
    });
    if (status === 0) {
      const list = [{shop_nick_name: '全部分院', shop_no: 0}, ...shop_list] || [];
      setShopIdx(0);
      setShopList(list);
      if (cb) cb(list);
    } else {
      Toast.fail(message);
    }
  };

  // 选择城市
  const onSelectCity = (idx, item, cb) => {
    console.log(idx, item);
    setCityIdx(idx);
    queryShopList(item.city_id, cb);
  };

  // 选择分院
  const onSelectShop = (idx, item, flag, initCityIdx) => {
    setShopIdx(idx);
    if (!flag) onToggle(-1);
    props.onChangeShop({shopInfo: item, cityInfo: cityList[initCityIdx ? initCityIdx : cityIdx]});
  };

  const onToggle = flag => {
    props.onToggle(flag);
  };

  return (
    <div className="city-shop-select">
      <div className="gst-select">
        <div className="gst-select-view" onClick={() => onToggle()}>
          <span className="val">{val}</span>
          <span className="icon icon-arrow" />
        </div>
        {isShow ? (
          <>
            <div className="gst-select-mask" />
            <div className="gst-select-content">
              <div className="city-wrapper">
                {cityList.map((item, idx) => (
                  <span key={idx} className={idx === cityIdx ? 'active' : ''} onClick={() => onSelectCity(idx, item)}>
                    {item.city_name}
                  </span>
                ))}
              </div>
              <div className="shop-wrapper">
                {shopList.map((item, idx) => (
                  <div
                    key={idx}
                    className={idx === shopIdx ? 'shop-item active' : 'shop-item'}
                    onClick={() => onSelectShop(idx, item)}
                  >
                    <span className="shop-txt">{item.shop_nick_name}</span>
                    {item.distance ? <span className="distance">{(item.distance / 1000).toFixed(2)}公里</span> : null}
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
});
